import { useState } from "react";

import useDialog from "@datanac/datanac-mui-toolkit/dist/hooks/useDialog";
import { Add } from "@mui/icons-material";
import { Box, Dialog } from "@mui/material";
import { FinancialIcon } from "components/Icons/Icons";
import { ButtonLargeSquare } from "mui-toolkit/ButtonLargeSquare";
import { v4 } from "uuid";

import { FinancialStatementSchedule_Accounts_Edit } from "./FinancialStatementSchedule_Accounts_EditDialog";
import ScheduleCard from "./ScheduleCard";
import { schedule_financial_statement_accounts_liquid } from "./useFinancialStatementSchedule";

/*

FinancialStatementSchedule_Accounts_View model
- Financial Institution name
- Account Type ["Cash", "Savings", "CD", "Money Market", "Other"]
- Value $
- Adjusted Value $
- Prior Value $

*/
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CHECKING = "Checking Account";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_RETIRMENT = "Retirement";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CASH = "Cash";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_SAVINGS = "Savings Account";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CD = "CD";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_MONEYMARKET = "Money Market";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_OTHER = "Other";

export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_SALES = "Sales";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_EXPENSE = "Expense";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_LIVESTOCK = "Livestock";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_PREPAID = "Prepaid";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_STOCKS = "Stocks";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_COMMODITIES = "Commodities";
export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_MORTGAGE = "Mortgage";

export const SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPES = [
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CHECKING,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_RETIRMENT,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CASH,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_SAVINGS,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_CD,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_MONEYMARKET,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_OTHER,

  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_SALES,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_EXPENSE,

  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_LIVESTOCK,

  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_PREPAID,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_STOCKS,
  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_COMMODITIES,

  SCHEDULE_FINANCIAL_STATEMENT_ACCOUNTTYPE_MORTGAGE,
];

// ---

export const SYSTEM_PROMPT_ACCOUNT_PARSER_LIQUID = "form_financialinterview_liquid";

export const FinancialStatementSchedule_Accounts_Liquid_View = ({ year, accounts, onChange, is_lender }) => {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const CATEGORY = schedule_financial_statement_accounts_liquid;

  const [editingItem, setEditingItem] = useState(null);

  const handleChange = async (account) => {
    if (!account.id) {
      account.id = v4();
    }
    if (!account.year && year) {
      account.year = year;
    }
    if (!account.category) {
      account.category = CATEGORY;
    }

    onChange && onChange(account);
  };

  const handleDeleteOnClick = (account) => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...account };
        _newState.is_active = false;
        handleChange(_newState);

        return false;
      },
    });
  };

  return (
    <>
      <Box className="cardContainer">
        {(accounts || [])
          ?.filter((item) => item.is_active != false)
          ?.map((item, index) => (
            <ScheduleCard
              key={index}
              Avatar={FinancialIcon}
              item={item}
              handleDeleteOnClick={handleDeleteOnClick}
              handleCardOnClick={() => setEditingItem(item)}
            />
          ))}

        <ButtonLargeSquare icon={<Add />} title={"Add New"} onClick={() => setEditingItem({})} />
      </Box>

      <Dialog open={Boolean(editingItem != null)}>
        <FinancialStatementSchedule_Accounts_Edit
          onChange={handleChange}
          onClose={() => setEditingItem(null)}
          account={editingItem}
          is_lender={is_lender}
        />
      </Dialog>

      {confirmDialogComponent}
    </>
  );
};
